import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { breakpoints, fontWeights, colors } from '@/styles'
import { LabeledValue, LabelText, ValueText } from '@/features/Application/elements'
import useMediaQuery from '@/hooks/use-media-query'

const SubTitleWrapper = styled.div`
  width: 50%;
  margin-bottom: 12px;
  @media only screen and (max-width: ${breakpoints.desktopSmall}) {
    width: 100%;
    margin-bottom: 0;
  }
`

const MobileTitle = styled.div`
  font-weight: ${fontWeights.medium};
  font-size: 16px;
  line-height: 20px;
  color: ${colors.grey16};
  background-color: #fafafa;
  border-bottom: 1px solid ${colors.grey88};
  margin: 0;
  padding: 12px;
`
type user = {
  first_name: string
  last_name: string
}

type BasicInfoProps = {
  user: user
  isLocked?: boolean
}

const BasicSubTitle: React.FC<BasicInfoProps> = ({ user, isLocked = false }) => {
  const { t } = useTranslation()
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const name = `${user?.first_name} ${user?.last_name}`

  return (
    <SubTitleWrapper>
      {displayMobile ? (
        <MobileTitle>{name}</MobileTitle>
      ) : (
        <LabeledValue
          key="name"
          label={<LabelText>{t('l.application.view.name.label', 'Name')}</LabelText>}
          value={<ValueText isLocked={isLocked}>{name}</ValueText>}
          showBorder={false}
        />
      )}
    </SubTitleWrapper>
  )
}

export default BasicSubTitle
